import { http } from 'src/services/accounts/http'

export enum Drivers {
  TELEGRAM = 'telegram',
  TWILIO = 'twilio',
  RC = 'ring-central',
}

export interface IGetAccounts {
  perPage?: number
  id?: number | string
  driver?: Drivers
  cursor?: string
}

export enum EAccountDriver {
  twilio = 'twilio',
  telegram = 'telegram',
  ringCentral = 'ring-central',
}
export enum EAccountStatus {
  unverified = 'unverified',
  active = 'active',
  inactive = 'inactive',
}
export interface IAccountNumber {
  id: number
  partnerSubdomain: string | null
  driver: EAccountDriver
  regionCode: string
  phoneNumber: string
  displayName: string
  active: boolean
  syncAt: string
  createdAt: string
  updatedAt: string
}
export interface IAccount {
  id: number
  identifier: string
  internalId: number
  driver: `${EAccountDriver}`
  status: `${EAccountStatus}`
  createdAt: string
  updatedAt: string
  fallbackTimeout: number
  fallbackNumber: string
  number: IAccountNumber
  assignedUserIds: number[]
}
export const getAccounts = ({
  id,
  driver,
  perPage = 25,
  cursor,
}: IGetAccounts) => {
  return http.get(`/accounts`, {
    params: {
      perPage,
      userId: id,
      driver,
      cursor,
    },
  })
}

export interface IDeleteAccountParams {
  accountId: number
}

export const deleteAccounts = ({ accountId }: IDeleteAccountParams) => {
  return http.delete(`/accounts/${accountId}`)
}

export interface IPostAccountsUpdateParams {
  accountId: number
  data: {
    fallbackTimeout?: number
    fallbackNumber?: string
  }
}

export const patchAccountsUpdate = ({
  accountId,
  data,
}: IPostAccountsUpdateParams) => {
  return http.patch<IAccount>(`/accounts/${accountId}`, data)
}

export interface IGetAccountParams {
  accountId: number
}
export const getAccount = ({ accountId }: IGetAccountParams) => {
  return http.get<IAccount>(`/accounts/${accountId}`)
}
